/**
 * SkipIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SkipIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M17 6a3 3 0 0 1 3 3v5.586l.793-.793a1 1 0 1 1 1.414 1.414l-2.5 2.5a1 1 0 0 1-.209.158l-.044.025a1 1 0 0 1-.197.075l-.05.012-.033.006a1 1 0 0 1-.107.013l-.047.003L19 18l-.02-.001-.054-.003-.053-.005q-.018-.002-.035-.006l-.057-.01-.027-.007a1 1 0 0 1-.292-.126 1 1 0 0 1-.169-.135l-2.5-2.5-.068-.076a1 1 0 0 1 1.406-1.406l.076.068.793.793V9a1 1 0 0 0-1-1H7l-.103.005A1 1 0 0 0 6 9v8a1 1 0 1 1-2 0V9a3 3 0 0 1 3-3z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SkipIcon = makeIcon('SkipIcon', SkipIconSvg)
